var $jq = jQuery.noConflict();

$jq(document).ready(function() {
		// stat slider 
		jQuery('.stats-slick-slider .stats__wrap').slick({
				infinite: false,
				slidesToShow: 3,
				responsive: [{
								breakpoint: 850,
								settings: {
										slidesToShow: 2,
								}
						},
						{
								breakpoint: 480,
								settings: {
										slidesToShow: 1,
										adaptiveHeight: true,
								}
						},
				],
		});

		// crop slider 
		jQuery('.crop-slick-slider .crop-block__wrap').slick({
				infinite: false,
				slidesToShow: 3,
				responsive: [{
								breakpoint: 850,
								settings: {
										slidesToShow: 2,
								}
						},
						{
								breakpoint: 480,
								settings: {
										slidesToShow: 1,
								}
						},
				],
		});

		// pubications filter bar url change 
		jQuery('.filter-bar select.postform').on('change', function(e) {
				e.preventDefault();
				window.location.href = jQuery(location).attr('origin') + jQuery(location).attr('pathname') + '?' + this.id + '=' + this.value + '#content-cards';
		});

		jQuery('.filter-bar .filter-item svg').on('click keypress', function(e) {
			e.preventDefault();
			window.location.href = jQuery(location).attr('origin') + jQuery(location).attr('pathname') + '#content-cards';
		});

		jQuery('.filter-bar .search-query svg').on('click keypress', function(e) {
			e.preventDefault();
			window.location.href = jQuery(location).attr('origin') + jQuery(location).attr('pathname') + '#content-cards';
		});

		// if we have our map, do the map things
		if (jQuery('.map-svg').length) {

				// baseline 
				const svgElem = jQuery('.map-svg');
				let [,,originalWidth, originalHeight] = svgElem.attr("viewBox").split(" ").map(Number);

				/* 
				* zoom on our map
				* (pathID) = id attr of the path to zoom on 
				*/
				function mapZoom(pathID) {

					// set some vars 
					let parentPos = document.getElementById('map-svg--wrapper').getBoundingClientRect(),
							childPos = document.getElementById(pathID).getBoundingClientRect(),
							relativePos = {},
							newSvgY,
							newSvgX;
					
					relativePos.top = childPos.top - parentPos.top,
					relativePos.right = childPos.right - parentPos.right,
					relativePos.bottom = childPos.bottom - parentPos.bottom,
					relativePos.left = childPos.left - parentPos.left;

					/* move x */
					newSvgX = ((relativePos.left + relativePos.right) / 2);

					/* move y */
					newSvgY = ((relativePos.top + relativePos.bottom) / 2);		

					if(parentPos.width < 960) {
						newSvgX = 0;
						newSvgY = 0;
						originalWidth = 1009;
						originalHeight = 666;
					}

					// set our viewbox and add our zoom class 
					svgElem.attr("viewBox", `${newSvgX} ${newSvgY} ${originalWidth} ${originalHeight}`);
					svgElem.addClass('country-active');
					document.getElementById(pathID).classList.add('active-path');
				}

				/* 
				* select change trigger 
				*/
				jQuery('.map-callout select').on('change', function(e) {
						e.preventDefault();
						let selMapID = this.value;

						if (selMapID != 'all') {
								// show hide if not all
								jQuery('.map-callout').addClass('hidden');
								jQuery(selMapID).toggleClass('hidden');
								jQuery('.map-callout select').prop('selectedIndex', 0);

								// for crops get data and make it work
								if (this.id == 'map-crop-select') {
										jQuery(`${selMapID} .crops-production li`).each(function() {
												let activeCountry = jQuery(this).attr('data-country');
												jQuery(`.map .map-svg path[data-map="#${activeCountry}"]`).addClass('prod-crop');
										});

										jQuery(`${selMapID} .crops-testing li`).each(function() {
												let testCountry = jQuery(this).attr('data-country');
												jQuery(`.map .map-svg path[data-map="#${testCountry}"]`).addClass('test-crop');
										});
								} 

								// zoom on solo country
								if(this.id == 'map-country-select') {
									let mapID = jQuery(`#map-svg path[data-map="${selMapID}"]`).attr('id');
									mapZoom(mapID);
								}
						}
				});

				/* 
				* reset items
				*/ 
				jQuery('.map-callout .reset').on('click keypress', function(e) {
						e.preventDefault();
						jQuery('.map-callout').addClass('hidden');
						jQuery('.map-callout.map-start').toggleClass('hidden');
						jQuery('.map .map-svg path').removeClass('prod-crop');
						jQuery('.map .map-svg path').removeClass('test-crop');
						jQuery('.map .map-svg path').removeClass('active-path');
						svgElem.attr("viewBox", `0 0 ${originalWidth} ${originalHeight}`);
						svgElem.removeClass('country-active');
				});

				/* 
				* into box close
				*/
				jQuery('.map-callout .svg-close').on('click keypress', function() {
						jQuery('.map-callout.map-start').toggleClass('collapsed');
				});

				/* 
				* on country click
				*/
				jQuery('.map-svg path').on('click keypress', function() {
						let mapID = jQuery(this).attr('data-map');
						
						jQuery('.map-callout').addClass('hidden');
						jQuery(mapID).toggleClass('hidden');
						jQuery('.map .map-svg path').removeClass('prod-crop');
						jQuery('.map .map-svg path').removeClass('test-crop');

						// PLZ
						let thisID = jQuery(this).attr('id');
						mapZoom(thisID);
				});
		}

});
